<form class="form-search-bar form-table" [formGroup]="entriesForm" (ngSubmit)="entriesSubmit()" autocomplete="off">
  <table class="kf-registration-table" mat-table [dataSource]="categories" formArrayName="entries" [multiTemplateDataRows]="true">
    <ng-container matColumnDef="entry">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" >
        {{category.description}}
        <span>Total</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> Total </td>
    </ng-container>

    <ng-container matColumnDef="ru">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Re-use
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Recycle.RU'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="ru"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="ruPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (click)="entriesControl.at(i).get('ru')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <span matSuffix>%</span>
          <mde-popover #ruPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('ru')?.hasError('max') || entriesControl.at(i)?.get('ru')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('ru')?.hasError('max') || entriesControl.at(i)?.get('ru')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="this.entriesControl.at(i)?.get('ru')?.hasError('max') && this.entriesControl.at(i)?.get('ru')?.value > 100">
                  The value can´t be higher than 100
                </p>
                <p *ngIf="entriesControl.at(i)?.get('ru')?.hasError('min') && this.entriesControl.at(i)?.get('ru')?.value < 0">
                  The value can´t be lower than 0
                </p>
                <p *ngIf="entriesControl.at(i)?.get('ru')?.hasError('max') && this.entriesControl.at(i)?.get('ru')?.value <= 100">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('ru')?.hasError('min') && this.entriesControl.at(i)?.get('ru')?.value >= 0">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="ruPopover._emitCloseEvent()">Close</button>
                <button *ngIf="this.entriesControl.at(i)?.get('ru')?.value <= 100 && this.entriesControl.at(i)?.get('ru')?.value >= 0" mat-raised-button type="button" color="primary" (click)="allowValidation('ru', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="mr">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info" matTooltip="Material Recovery">
          MR
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Recycle.MR'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
            <input onfocus="this.select()" class="input-number" type="number" matInput formControlName="mr"
                   [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                   (change)="sum()"
                   [mdePopoverTriggerFor]="mrPopover"
                   mdePopoverTriggerOn="none"
                   mdePopoverArrowColor="none"
                   (click)="entriesControl.at(i).get('mr')?.invalid ? popoverTrigger.openPopover() : null"
                   #popoverTrigger="mdePopoverTrigger"
            />
          <span matSuffix>%</span>
          <mde-popover #mrPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('mr')?.hasError('max') || entriesControl.at(i)?.get('mr')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('mr')?.hasError('max') || entriesControl.at(i)?.get('mr')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="this.entriesControl.at(i)?.get('mr')?.hasError('max') && this.entriesControl.at(i)?.get('mr')?.value > 100">
                  The value can´t be higher than 100
                </p>
                <p *ngIf="entriesControl.at(i)?.get('mr')?.hasError('min') && this.entriesControl.at(i)?.get('mr')?.value < 0">
                  The value can´t be lower than 0
                </p>
                <p *ngIf="entriesControl.at(i)?.get('mr')?.hasError('max') && this.entriesControl.at(i)?.get('mr')?.value <= 100">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('mr')?.hasError('min') && this.entriesControl.at(i)?.get('mr')?.value >= 0">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="mrPopover._emitCloseEvent()">Close</button>
                <button *ngIf="this.entriesControl.at(i)?.get('mr')?.value <= 100 && this.entriesControl.at(i)?.get('mr')?.value >= 0" mat-raised-button type="button" color="primary" (click)="allowValidation('mr', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="omr">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info" matTooltip="Other Material Recycling">
          OMR
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Recycle.OMR'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="omr"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="omrPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (click)="entriesControl.at(i).get('omr')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <span matSuffix>%</span>
          <mde-popover #omrPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('omr')?.hasError('max') || entriesControl.at(i)?.get('omr')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('omr')?.hasError('max') || entriesControl.at(i)?.get('omr')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="this.entriesControl.at(i)?.get('omr')?.hasError('max') && this.entriesControl.at(i)?.get('omr')?.value > 100">
                  The value can´t be higher than 100
                </p>
                <p *ngIf="entriesControl.at(i)?.get('omr')?.hasError('min') && this.entriesControl.at(i)?.get('omr')?.value < 0">
                  The value can´t be lower than 0
                </p>
                <p *ngIf="entriesControl.at(i)?.get('omr')?.hasError('max') && this.entriesControl.at(i)?.get('omr')?.value <= 100">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('omr')?.hasError('min') && this.entriesControl.at(i)?.get('omr')?.value >= 0">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="omrPopover._emitCloseEvent()">Close</button>
                <button *ngIf="this.entriesControl.at(i)?.get('omr')?.value <= 100 && this.entriesControl.at(i)?.get('omr')?.value >= 0" mat-raised-button type="button" color="primary" (click)="allowValidation('omr', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="er">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info" matTooltip="Energy Recovery">
          ER
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Recycle.ER'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="er"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="erPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (click)="entriesControl.at(i).get('er')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <span matSuffix>%</span>
          <mde-popover #erPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('er')?.hasError('max') || entriesControl.at(i)?.get('er')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('er')?.hasError('max') || entriesControl.at(i)?.get('er')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="this.entriesControl.at(i)?.get('er')?.hasError('max') && this.entriesControl.at(i)?.get('er')?.value > 100">
                  The value can´t be higher than 100
                </p>
                <p *ngIf="entriesControl.at(i)?.get('er')?.hasError('min') && this.entriesControl.at(i)?.get('er')?.value < 0">
                  The value can´t be lower than 0
                </p>
                <p *ngIf="entriesControl.at(i)?.get('er')?.hasError('max') && this.entriesControl.at(i)?.get('er')?.value <= 100">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('er')?.hasError('min') && this.entriesControl.at(i)?.get('er')?.value >= 0">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="erPopover._emitCloseEvent()">Close</button>
                <button *ngIf="this.entriesControl.at(i)?.get('er')?.value <= 100 && this.entriesControl.at(i)?.get('er')?.value >= 0" mat-raised-button type="button" color="primary" (click)="allowValidation('er', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="td">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info" matTooltip="Thermal Disposal">
          TD
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Recycle.TD'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="td"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="tdPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (click)="entriesControl.at(i).get('td')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <span matSuffix>%</span>
          <mde-popover #tdPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('td')?.hasError('max') || entriesControl.at(i)?.get('td')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('td')?.hasError('max') || entriesControl.at(i)?.get('td')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="this.entriesControl.at(i)?.get('td')?.hasError('max') && this.entriesControl.at(i)?.get('td')?.value > 100">
                  The value can´t be higher than 100
                </p>
                <p *ngIf="entriesControl.at(i)?.get('td')?.hasError('min') && this.entriesControl.at(i)?.get('td')?.value < 0">
                  The value can´t be lower than 0
                </p>
                <p *ngIf="entriesControl.at(i)?.get('td')?.hasError('max') && this.entriesControl.at(i)?.get('td')?.value <= 100">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('td')?.hasError('min') && this.entriesControl.at(i)?.get('td')?.value >= 0">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="tdPopover._emitCloseEvent()">Close</button>
                <button *ngIf="this.entriesControl.at(i)?.get('td')?.value <= 100 && this.entriesControl.at(i)?.get('td')?.value >= 0" mat-raised-button type="button" color="primary" (click)="allowValidation('td', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="ld">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Landfill
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Recycle.LD'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="ld"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="ldPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (click)="entriesControl.at(i).get('ld')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <span matSuffix>%</span>
          <mde-popover #ldPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('ld')?.hasError('max') || entriesControl.at(i)?.get('ld')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('ld')?.hasError('max') || entriesControl.at(i)?.get('ld')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="this.entriesControl.at(i)?.get('ld')?.hasError('max') && this.entriesControl.at(i)?.get('ld')?.value > 100">
                  The value can´t be higher than 100
                </p>
                <p *ngIf="entriesControl.at(i)?.get('ld')?.hasError('min') && this.entriesControl.at(i)?.get('ld')?.value < 0">
                  The value can´t be lower than 0
                </p>
                <p *ngIf="entriesControl.at(i)?.get('ld')?.hasError('max') && this.entriesControl.at(i)?.get('ld')?.value <= 100">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('ld')?.hasError('min') && this.entriesControl.at(i)?.get('ld')?.value >= 0">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="ldPopover._emitCloseEvent()">Close</button>
                <button *ngIf="this.entriesControl.at(i)?.get('ld')?.value <= 100 && this.entriesControl.at(i)?.get('ld')?.value >= 0" mat-raised-button type="button" color="primary" (click)="allowValidation('ld', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="loss">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Loss
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Recycle.Loss'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="loss"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="lossPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (click)="entriesControl.at(i).get('loss')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <span matSuffix>%</span>
          <mde-popover #lossPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('loss')?.hasError('max') || entriesControl.at(i)?.get('loss')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('loss')?.hasError('max') || entriesControl.at(i)?.get('loss')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="this.entriesControl.at(i)?.get('loss')?.hasError('max') && this.entriesControl.at(i)?.get('loss')?.value > 100">
                  The value can´t be higher than 100
                </p>
                <p *ngIf="entriesControl.at(i)?.get('loss')?.hasError('min') && this.entriesControl.at(i)?.get('loss')?.value < 0">
                  The value can´t be lower than 0
                </p>
                <p *ngIf="entriesControl.at(i)?.get('loss')?.hasError('max') && this.entriesControl.at(i)?.get('loss')?.value <= 100">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('loss')?.hasError('min') && this.entriesControl.at(i)?.get('loss')?.value >= 0">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="lossPopover._emitCloseEvent()">Close</button>
                <button *ngIf="this.entriesControl.at(i)?.get('loss')?.value <= 100 && this.entriesControl.at(i)?.get('loss')?.value >= 0" mat-raised-button type="button" color="primary" (click)="allowValidation('loss', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Total
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Recycle.Total'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" #totalInput matInput type="number" formControlName="total"
                 [ngClass]="totalInput.value !== '100.00' ? 'error-100' : ''"
                 matTooltip="{{totalInput.value !== '100.00' ? 'The total value must add up to 100%': null}}"
                 [readonly]="true"
                 (change)="sum()"/>
          <p [ngClass]="totalInput.value !== '100.00' ? 'error-100' : ''" matSuffix>%</p>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="remark">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Remark
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Recycle.Remark'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input matInput type="text" formControlName="remark"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"/>
        </mat-form-field>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <p class="mat-error" *ngIf="entriesForm.invalid">
    Please correct or confirm values that are negative or different from those of the previous year - highlighted in red in the form. (Please click on cells containing values or click on Save to discover the error).
  </p>
  <p class="mat-error" *ngIf="!this.allTotalIs100">
    Some values do not add up to 100%, check them and make sure they are correct before marking as completed.
  </p>
  <div class="wizard-buttons-container align-right">
    <button mat-raised-button color="primary" type="button" #markAsCompletedButton
            (click)="!markAsCompletedButton.disabled ? markAsCompleted() : ''"
            *ngIf="!simpleUser"
            [disabled]="kfRegistrationDetail?.kfRegistration?.completionStatus || entriesForm.invalid
            || kfRegistrationDetail === undefined">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span> Mark as completed</span>
    </button>
    <button mat-raised-button class="reset" type="button"
            (click)="reset()"
            *ngIf="!simpleUser"
            [disabled]="kfRegistrationDetail?.kfRegistration?.completionStatus || kfRegistrationDetail === undefined">
      <span>Reset </span>
      <mat-icon class="material-icons-outlined">refresh</mat-icon>
    </button>
    <button mat-raised-button matStepperPrevious type="button">
      <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
      <span>Back</span>
    </button>
    <button mat-raised-button type="submit" color="primary"
            *ngIf="!kfRegistrationDetail?.kfRegistration?.completionStatus && !simpleUser">
      <span>Save</span>
      <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
    </button>
    <button mat-raised-button type="button" color="primary"
            (click)="this.redirectUrlEmitter.emit()">
      <mat-icon class="material-icons-outlined">undo</mat-icon>
      <span>Return</span>
    </button>
  </div>
</form>
